import { createContext, useContext, useId, useMemo } from 'react';

export type ChartTimeRange = {
  min: string;
  max: string;
};

type ChartInteractionContextValue = {
  sync_id: string;
  onTimeRangeSelected?: (range: ChartTimeRange) => void;
};

const ChartInteractionContext = createContext<ChartInteractionContextValue | null>(null);

export const useChartInteractionGroup = () => useContext(ChartInteractionContext);

const ChartInteractionGroup: React.FC<{
  children: React.ReactNode;
  onTimeRangeSelected?: (range: ChartTimeRange) => void;
}> = ({ children, onTimeRangeSelected }) => {
  const id = useId();
  const value = useMemo(
    () => ({
      sync_id: `metric-chart-${id}`,
      onTimeRangeSelected,
    }),
    [id, onTimeRangeSelected],
  );

  return (
    <ChartInteractionContext.Provider value={value}>{children}</ChartInteractionContext.Provider>
  );
};

export default ChartInteractionGroup;
